import React, { Component } from 'react';
import './CreatorUploadMonetizationForm.css';
import CreatorMonetizationRoyaltyForm from './CreatorMonetizationRoyaltyForm';
import CreatorMonetizationImpressionPercentageForm from './CreatorMonetizationImpressionPercentageForm';
import CreatorMonetizationImpressionForm from './CreatorMonetizationImpressionForm';
import CreatorMonetizationEditionsForm from './CreatorMonetizationEditionsForm';
import CreatorMonetizationMintPriceForm from './CreatorMonetizationMintPriceForm';

class CreatorUploadMonetizationForm extends Component {
  render() {
    return (
      <div>
        <CreatorMonetizationRoyaltyForm checkString={this.props.checkString} setRoyalty={this.props.setRoyalty} params={this.props.params}/>
        <CreatorMonetizationImpressionForm usdPrice={this.props.usdPriceMATIC} checkString={this.props.checkStringWithDecimal} setImpressionFee={this.props.setImpressionFee} params={this.props.params}/>
        <CreatorMonetizationImpressionPercentageForm checkString={this.props.checkStringWithHalfIncrements} setImpressionPercentage={this.props.setImpressionPercentage} params={this.props.params}/>
        <CreatorMonetizationEditionsForm checkString={this.props.checkString} setEditions={this.props.setEditions} params={this.props.params}/>
        <CreatorMonetizationMintPriceForm usdPrice={this.props.usdPriceETH} checkString={this.props.checkStringWithDecimal} setMintPrice={this.props.setMintPrice} params={this.props.params}/>
      </div>
    );
  }
}

export default CreatorUploadMonetizationForm;
